export interface TableColumn<
  T extends Record<string, any> = Record<string, any>
> {
  key: keyof T | string;
  header: string;
  align?: 'left' | 'center' | 'right';
  className?: string;
  headerClassName?: string;
}

export type TableRow<T extends Record<string, any> = Record<string, any>> =
  T & {
    highlight?: boolean;
  };

export const TABLE_STYLES = [
  { label: 'Default', value: '' },
  { label: 'Styled - Light Green', value: 'styled-light-green' },
];
export type TableStylesType = (typeof TABLE_STYLES)[number]['value'];

export interface BaseFixedFirstColumnTableProps {
  columns: TableColumn[];
  tableData: TableRow[];
  tableStyle: TableStylesType;
  centeredInParent?: boolean;
  className?: string;
  enableHighlighting?: boolean;
  hideHeader?: boolean;
  renderCell?: (column: TableColumn, row: TableRow) => React.ReactNode;
  rowKeyField?: string; // Field to use as unique key for each row
  striped?: boolean;
  transposed?: boolean; // When true, flips columns and rows
}

export type Data = {
  attributes: {
    header: string;
    value: string;
  }[];
  highlight?: boolean;
  id?: string;
};

export interface FixedFirstColumnTableProps {
  centeredInParent?: boolean;
  className?: string;
  data?: Data[];
  rowKeyField?: string; // Field to use as unique key for each row
  hideHeader?: boolean;
  striped?: boolean;
  tableStyle?: TableStylesType;
  transposed?: boolean; // When true, flips columns and rows
}
